interface TranslateTaskContent {
    /**
     * 源语言
     */
    source_lang: string;
    /**
     * 目标语言
     */
    target_lang: string;
    /**
     * 翻译任务内容
     */
    user_input: string;
}

export interface ApiCreateSyncTranslateTaskRequest {
    /**
     * 任务 ID
     */
    task_id: string;
    /**
     * 任务类型
     */
    type: 'AI_TRANSLATION';
    /**
     * 任务内容
     */
    content: TranslateTaskContent;
}

export type ApiCreateSyncTranslateTaskResponse = void;

/**
 * 创建同步翻译任务
 */
export interface CreateSyncTranslateTaskApi {
    /**
     * 创建同步翻译任务
     * @param data 创建异步翻译任务请求
     */
    createSyncTranslateTask(data: ApiCreateSyncTranslateTaskRequest): Promise<ApiCreateSyncTranslateTaskResponse>;
}

export const CreateSyncTranslateTaskApi = Symbol('CreateSyncTranslateTaskApi');
